import { render, staticRenderFns } from "./BackgroundDeleteButton.vue?vue&type=template&id=246b81b2&"
import script from "./BackgroundDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./BackgroundDeleteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports